import React from "react";
import { FaExclamationTriangle } from "react-icons/fa";

const DeleteConfirmBox = ({ onBackDrop, onConfirm, onCancel, message }) => {
  return (
    <>
      <div
        onClick={onBackDrop}
        className="bg-black opacity-75 fixed top-0 left-0 h-screen w-screen z-10"
      ></div>
      {/* <div className="confirmbox"> */}
      <div className="bg-primary fixed xs:w-[500px] w-[300px] border border-[#EEEEF0] rounded-md z-20 xs:top-[calc(50%-140px)] xs:left-[calc(50%-250px)] top-[calc(50%-170px)] left-[calc(50%-150px)]">
        <div className="flex flex-col justify-center items-center w-full h-full gap-5 p-5">
          <div className="text-center">
            <span className="text-[18px] font-semibold">Delete {message}</span>
            <p className="text-textPrimary text-center tracking-[0.5px] ">
              Are you sure you want to delete?
            </p>
          </div>
          <div className="flex bg-[#FFE9D9] border-l-4 border-[#FA703F] p-4 gap-3 items-center">
            <FaExclamationTriangle className="text-[36px] text-[#771505]" />
            <span className="text-sm text-[#BC4C2E]">
              This will delete permanently and you will not be able to recover
              or undo the action.
            </span>
          </div>

          <div className="flex sm:flex-row gap-y-5 flex-col sm:justify-between justify-center sm:w-full">
            <button
              type="button"
              className="font-semibold h-10 w-[140px] border-2 border-green-700 text-green-700  rounded-sm"
              onClick={onCancel}
            >
              No, Cancel
            </button>
            <button
              type="button"
              className="font-semibold  h-10 w-[140px] bg-red-500 text-white rounded-sm"
              onClick={onConfirm}
            >
              Yes, Delete
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeleteConfirmBox;
